<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  props: {
    purchaseHistorList: Array,
    sourceData: Object
  },
  watch: {
    purchaseHistorList: function(newVal, oldVal){
      this.purchaseHistorList = newVal
    },
    sourceData: function(newVal, oldVal){
      this.pageCount = newVal.totalPages
    }
  },
  data() {
    const pageCount = this.sourceData.totalPages;
    return {
      checkBoxSelect: true,
      closePayment: false,
      defaultValue: {},
      pageCount,
      activePage: this.sourceData.number + 1
    };
  },
  methods: {
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      if(!val) val = 1;
      this.activePage = val;
      let params = {
        page: this.activePage - 1
      };
      this.$emit("handleCurrentChange", "purchaseHistorList", params);
    }
  }
};
</script>

<template>
  <div class="AgentDetailPurchaseHistoryIndex">
    <el-table
      :data="purchaseHistorList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="createdAt" align="left" label="购买日期" min-width="100"></el-table-column>
      <el-table-column prop="operatorName" align="left" label="操作人" min-width="100"></el-table-column>
      <el-table-column prop="operateType" align="left" label="操作类型" min-width="100"></el-table-column>
      <el-table-column prop="courseCount" align="left" label="购买疗程" min-width="100"></el-table-column>
      <el-table-column prop="unitPrice" align="left" label="支付金额(元)" min-width="100"></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailPurchaseHistoryIndex {
  .AgencyAccountTable {
    margin: 20px 2%;
    border: 1px;
    width: 97%;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
// .paymentConfirmClass {
//   .el-message-box__content {
//     font-size: 18px;
//     color: #303133;
//   }
//   .el-button--small,
//   .el-button--small.is-round {
//     width: 90%;
//     height: 35px;
//     font-size: 14px;
//     background-color: #00c1de;
//     border-color: #00c1de;
//   }
//   border-radius: 12px;
// }
</style>





// WEBPACK FOOTER //
// src/components/patientManagement/PurchaseHistory.vue